import script from "./FaceMoveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaceMoveModal.vue?vue&type=script&setup=true&lang=ts"

import "./FaceMoveModal.vue?vue&type=style&index=0&id=b6cb8c9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6cb8c9a"]])

export default __exports__